import { useLocation } from 'react-router-dom';
import { useInvokeCallbackOnceWhen } from './useInvokeCallbackOnceWhen';
import { logEvent } from '@/ga';
import { getPageKey, SCREEN_VIEW_GA } from '@/constants/ga';

function useScreenViewGa() {
  const location = useLocation();
  const pageKey = getPageKey(location.pathname);

  useInvokeCallbackOnceWhen(() => {
    if (pageKey) {
      logEvent(SCREEN_VIEW_GA, {
        screen_name: pageKey,
      });
    }
  }, !!pageKey);

  return true;
}

export default useScreenViewGa;
